import { NumberField } from '@shared/data/entity/fields/NumberField';

/** A number field as text, in its format: "$1,200.00", "12.5%". */
export function getNumberText(field: NumberField): string {
  return field.formattedValue;
}
